<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  viewBox="0 0 512 512"
>
  <path
    d="M298.667 176.044V0h-85.333v176.044c-73.61 18.945-128 85.766-128 165.289C85.333 435.59 161.744 512 256 512s170.667-76.41 170.667-170.667c0-79.523-54.39-146.343-128-165.289z"
    fill="#b4d8f1"
  />
  <path
    d="M298.667 176.044V0H256v512c94.256 0 170.667-76.41 170.667-170.667 0-79.523-54.39-146.343-128-165.289z"
    fill="#98c8ed"
  />
  <path
    d="M85.333 341.333C85.333 435.59 161.744 512 256 512s170.667-76.41 170.667-170.667H85.333z"
    fill="#e592bf"
  />
  <path d="M213.333 0h85.333v85.333h-85.333z" fill="#a58868" />
  <path d="M256 0h42.667v85.333H256z" fill="#947859" />
  <path
    d="M256 341.333V512c94.256 0 170.667-76.41 170.667-170.667H256z"
    fill="#e176af"
  />
</svg>
